import { render } from "./LegacyGroupSystemHealthReport.vue?vue&type=template&id=1758f840"
import script from "./LegacyGroupSystemHealthReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupSystemHealthReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__